import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Search, ChevronDown, Star, Gift, X, Phone, Mail, MapPin, Calendar, MessageSquare, Save } from 'lucide-react';
const CUSTOMER_TABS = [{
  label: 'Overview',
  path: ''
}, {
  label: 'Database',
  path: 'database'
}, {
  label: 'Segments',
  path: 'segments'
}, {
  label: 'Reviews',
  path: 'reviews'
}, {
  label: 'Insights',
  path: 'insights'
}];
const CUSTOMERS = [{
  id: 1,
  name: 'Marko Petrović',
  phone: '+381 64 XXX XXX',
  email: 'marko.p@email.com',
  source: 'Collina.rs',
  segment: 'VIP',
  orders: 42,
  spent: '98,500 RSD',
  avgOrder: '2,345 RSD',
  lastOrder: '2 days ago',
  rating: 9.8,
  loyalty: 2450,
  firstOrder: 'Mar 15, 2025',
  location: 'Vračar',
  frequency: 'Every 5 days'
}, {
  id: 2,
  name: 'Ana Marković',
  phone: '+381 63 XXX XXX',
  email: 'ana.m@email.com',
  source: 'WhatsApp',
  segment: 'Regular',
  orders: 18,
  spent: '42,300 RSD',
  avgOrder: '2,350 RSD',
  lastOrder: '5 days ago',
  rating: 9.5,
  loyalty: 890,
  firstOrder: 'Jun 10, 2025',
  location: 'NBG',
  frequency: 'Every 8 days'
}, {
  id: 3,
  name: 'Nikola Radović',
  phone: '+381 62 XXX XXX',
  email: 'nikola.r@email.com',
  source: 'Wolt',
  segment: 'New',
  orders: 1,
  spent: '1,890 RSD',
  avgOrder: '1,890 RSD',
  lastOrder: 'Yesterday',
  rating: null,
  loyalty: null,
  firstOrder: 'Dec 14, 2025',
  location: 'Zemun',
  frequency: 'First order'
}];
export function Database() {
  const [selectedCustomer, setSelectedCustomer] = useState<(typeof CUSTOMERS)[0] | null>(null);
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-678">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-679">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-680">
          Customer Database
        </h1>
        <div className="flex flex-wrap gap-3 items-center" data-id="element-681">
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-682">
            All Segments <ChevronDown size={14} data-id="element-683" />
          </button>
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-684">
            All Locations <ChevronDown size={14} data-id="element-685" />
          </button>
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-686">
            All Sources <ChevronDown size={14} data-id="element-687" />
          </button>
          <div className="relative" data-id="element-688">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary" data-id="element-689" />
            <input type="text" placeholder="Search customers..." className="bg-background-elevated border border-white/10 rounded-lg pl-9 pr-4 py-2 text-sm focus:outline-none focus:border-accent-primary w-64" data-id="element-690" />
          </div>
        </div>
      </div>

      <TabNavigation tabs={CUSTOMER_TABS} basePath="/customers" data-id="element-691" />

      <Card noPadding className="overflow-hidden" data-id="element-692">
        <table className="w-full text-sm text-left" data-id="element-693">
          <thead className="bg-white/5 text-text-secondary font-medium border-b border-white/10" data-id="element-694">
            <tr data-id="element-695">
              <th className="p-4" data-id="element-696">Customer</th>
              <th className="p-4" data-id="element-697">Segment</th>
              <th className="p-4" data-id="element-698">Orders</th>
              <th className="p-4" data-id="element-699">Total Spent</th>
              <th className="p-4" data-id="element-700">Avg Order</th>
              <th className="p-4" data-id="element-701">Last Order</th>
              <th className="p-4" data-id="element-702">Rating</th>
              <th className="p-4" data-id="element-703">Loyalty</th>
              <th className="p-4 text-right" data-id="element-704">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5" data-id="element-705">
            {CUSTOMERS.map(customer => <tr key={customer.id} className="hover:bg-white/5 transition-colors" data-id="element-706">
                <td className="p-4" data-id="element-707">
                  <div className="font-bold" data-id="element-708">{customer.name}</div>
                  <div className="text-xs text-text-secondary" data-id="element-709">
                    {customer.phone}
                  </div>
                  <div className="mt-1 inline-block px-1.5 py-0.5 rounded text-[10px] bg-white/10 text-text-secondary uppercase" data-id="element-710">
                    {customer.source}
                  </div>
                </td>
                <td className="p-4" data-id="element-711">
                  {customer.segment === 'VIP' && <span className="inline-flex items-center gap-1 px-2 py-1 rounded bg-accent-primary/20 text-accent-primary text-xs font-bold" data-id="element-712">
                      👑 VIP
                    </span>}
                  {customer.segment === 'Regular' && <span className="inline-flex items-center gap-1 px-2 py-1 rounded bg-yellow-500/20 text-yellow-500 text-xs font-bold" data-id="element-713">
                      ⭐ Regular
                    </span>}
                  {customer.segment === 'New' && <span className="inline-flex items-center gap-1 px-2 py-1 rounded bg-blue-500/20 text-blue-500 text-xs font-bold" data-id="element-714">
                      🆕 New
                    </span>}
                </td>
                <td className="p-4" data-id="element-715">{customer.orders}</td>
                <td className="p-4 font-medium" data-id="element-716">{customer.spent}</td>
                <td className="p-4 text-text-secondary" data-id="element-717">{customer.avgOrder}</td>
                <td className="p-4 text-text-secondary" data-id="element-718">
                  {customer.lastOrder}
                </td>
                <td className="p-4" data-id="element-719">
                  {customer.rating ? <div className="flex items-center gap-1 font-bold" data-id="element-720">
                      {customer.rating}{' '}
                      <Star size={12} className="text-accent-success" fill="currentColor" data-id="element-721" />
                    </div> : <span className="text-text-secondary" data-id="element-722">—</span>}
                </td>
                <td className="p-4" data-id="element-723">
                  {customer.loyalty ? <div className="flex items-center gap-1 text-accent-success font-medium" data-id="element-724">
                      <Gift size={12} data-id="element-725" /> {customer.loyalty} pts
                    </div> : <span className="text-text-secondary" data-id="element-726">—</span>}
                </td>
                <td className="p-4 text-right" data-id="element-727">
                  <Button size="sm" variant="secondary" onClick={() => setSelectedCustomer(customer)} data-id="element-728">
                    View
                  </Button>
                </td>
              </tr>)}
          </tbody>
        </table>
        <div className="p-4 border-t border-white/10 flex justify-between items-center text-sm text-text-secondary" data-id="element-729">
          <div data-id="element-730">Showing 1-50 of 2,847 customers</div>
          <div className="flex gap-2" data-id="element-731">
            <Button size="sm" variant="secondary" disabled data-id="element-732">
              ◀ Prev
            </Button>
            <Button size="sm" variant="secondary" data-id="element-733">
              Next ▶
            </Button>
          </div>
        </div>
      </Card>

      {/* Customer Detail Modal */}
      {selectedCustomer && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-id="element-734">
          <Card className="w-full max-w-2xl max-h-[90vh] overflow-y-auto p-0" data-id="element-735">
            <div className="p-6 border-b border-white/10 bg-background-elevated sticky top-0 z-10" data-id="element-736">
              <div className="flex justify-between items-start" data-id="element-737">
                <div data-id="element-738">
                  <h2 className="text-2xl font-bold flex items-center gap-2" data-id="element-739">
                    {selectedCustomer.segment === 'VIP' && '👑'}{' '}
                    {selectedCustomer.name}
                    <span className="text-xs font-normal bg-white/10 px-2 py-1 rounded text-text-secondary uppercase tracking-wider" data-id="element-740">
                      {selectedCustomer.segment} Customer
                    </span>
                  </h2>
                  <div className="text-text-secondary mt-1 flex flex-wrap gap-4 text-sm" data-id="element-741">
                    <span className="flex items-center gap-1" data-id="element-742">
                      <Phone size={14} data-id="element-743" /> {selectedCustomer.phone}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-744">
                      <Mail size={14} data-id="element-745" /> {selectedCustomer.email}
                    </span>
                  </div>
                  <div className="mt-2 text-sm flex gap-4" data-id="element-746">
                    <span data-id="element-747">
                      Source:{' '}
                      <span className="text-white" data-id="element-748">
                        {selectedCustomer.source}
                      </span>
                    </span>
                    {selectedCustomer.loyalty && <span className="text-accent-success flex items-center gap-1" data-id="element-749">
                        <Gift size={14} data-id="element-750" /> WhatsApp Loyalty:{' '}
                        <strong data-id="element-751">{selectedCustomer.loyalty} pts</strong>
                      </span>}
                  </div>
                </div>
                <button onClick={() => setSelectedCustomer(null)} className="text-text-secondary hover:text-white" data-id="element-752">
                  <X size={24} data-id="element-753" />
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6" data-id="element-754">
              {/* Stats Grid */}
              <div className="grid grid-cols-4 gap-4" data-id="element-755">
                <div className="bg-white/5 p-3 rounded-lg text-center" data-id="element-756">
                  <div className="text-xs text-text-secondary uppercase mb-1" data-id="element-757">
                    Orders
                  </div>
                  <div className="font-bold text-lg" data-id="element-758">
                    {selectedCustomer.orders}
                  </div>
                </div>
                <div className="bg-white/5 p-3 rounded-lg text-center" data-id="element-759">
                  <div className="text-xs text-text-secondary uppercase mb-1" data-id="element-760">
                    Spent
                  </div>
                  <div className="font-bold text-lg" data-id="element-761">
                    {selectedCustomer.spent}
                  </div>
                </div>
                <div className="bg-white/5 p-3 rounded-lg text-center" data-id="element-762">
                  <div className="text-xs text-text-secondary uppercase mb-1" data-id="element-763">
                    Avg
                  </div>
                  <div className="font-bold text-lg" data-id="element-764">
                    {selectedCustomer.avgOrder}
                  </div>
                </div>
                <div className="bg-white/5 p-3 rounded-lg text-center" data-id="element-765">
                  <div className="text-xs text-text-secondary uppercase mb-1" data-id="element-766">
                    Rating
                  </div>
                  <div className="font-bold text-lg flex items-center justify-center gap-1" data-id="element-767">
                    {selectedCustomer.rating || '-'}{' '}
                    <Star size={14} className="text-accent-success" fill="currentColor" data-id="element-768" />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-6 text-sm" data-id="element-769">
                <div className="space-y-2" data-id="element-770">
                  <div className="flex justify-between border-b border-white/5 pb-2" data-id="element-771">
                    <span className="text-text-secondary" data-id="element-772">First order</span>
                    <span data-id="element-773">{selectedCustomer.firstOrder}</span>
                  </div>
                  <div className="flex justify-between border-b border-white/5 pb-2" data-id="element-774">
                    <span className="text-text-secondary" data-id="element-775">Customer for</span>
                    <span data-id="element-776">9 months</span>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-777">
                  <div className="flex justify-between border-b border-white/5 pb-2" data-id="element-778">
                    <span className="text-text-secondary" data-id="element-779">
                      Preferred location
                    </span>
                    <span data-id="element-780">{selectedCustomer.location}</span>
                  </div>
                  <div className="flex justify-between border-b border-white/5 pb-2" data-id="element-781">
                    <span className="text-text-secondary" data-id="element-782">Frequency</span>
                    <span data-id="element-783">{selectedCustomer.frequency}</span>
                  </div>
                </div>
              </div>

              {/* Favorite Items */}
              <div data-id="element-784">
                <h3 className="font-bold text-sm text-text-secondary uppercase mb-3" data-id="element-785">
                  Favorite Items
                </h3>
                <ul className="space-y-2 text-sm" data-id="element-786">
                  <li className="flex justify-between" data-id="element-787">
                    <span data-id="element-788">• BIG Double Collina Smash</span>
                    <span className="text-text-secondary" data-id="element-789">28 times</span>
                  </li>
                  <li className="flex justify-between" data-id="element-790">
                    <span data-id="element-791">• Pomfrit veliki</span>
                    <span className="text-text-secondary" data-id="element-792">24 times</span>
                  </li>
                  <li className="flex justify-between" data-id="element-793">
                    <span data-id="element-794">• Pepsi 0.5</span>
                    <span className="text-text-secondary" data-id="element-795">22 times</span>
                  </li>
                </ul>
              </div>

              {/* Recent Orders */}
              <div data-id="element-796">
                <div className="flex justify-between items-center mb-3" data-id="element-797">
                  <h3 className="font-bold text-sm text-text-secondary uppercase" data-id="element-798">
                    Recent Orders
                  </h3>
                  <Button size="sm" variant="secondary" data-id="element-799">
                    View All {selectedCustomer.orders} Orders
                  </Button>
                </div>
                <div className="space-y-2 text-sm" data-id="element-800">
                  <div className="flex justify-between items-center p-3 bg-white/5 rounded" data-id="element-801">
                    <div data-id="element-802">
                      <div className="font-bold" data-id="element-803">Dec 13</div>
                      <div className="text-text-secondary" data-id="element-804">
                        BIG Double + Pomfrit
                      </div>
                    </div>
                    <div className="text-right" data-id="element-805">
                      <div className="font-bold" data-id="element-806">2,340 RSD</div>
                      <div className="flex items-center justify-end gap-2 text-xs text-text-secondary" data-id="element-807">
                        <span className="flex items-center gap-1 text-accent-success font-bold" data-id="element-808">
                          <Star size={10} fill="currentColor" data-id="element-809" /> 10
                        </span>
                        <span data-id="element-810">{selectedCustomer.location}</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-white/5 rounded" data-id="element-811">
                    <div data-id="element-812">
                      <div className="font-bold" data-id="element-813">Dec 8</div>
                      <div className="text-text-secondary" data-id="element-814">2x Triple Smash</div>
                    </div>
                    <div className="text-right" data-id="element-815">
                      <div className="font-bold" data-id="element-816">4,280 RSD</div>
                      <div className="flex items-center justify-end gap-2 text-xs text-text-secondary" data-id="element-817">
                        <span className="flex items-center gap-1 text-accent-success font-bold" data-id="element-818">
                          <Star size={10} fill="currentColor" data-id="element-819" /> 10
                        </span>
                        <span data-id="element-820">{selectedCustomer.location}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Notes */}
              <div data-id="element-821">
                <h3 className="font-bold text-sm text-text-secondary uppercase mb-3" data-id="element-822">
                  Notes
                </h3>
                <div className="flex gap-2" data-id="element-823">
                  <textarea className="flex-1 bg-background border border-white/10 rounded-lg p-3 text-sm focus:outline-none focus:border-accent-primary min-h-[80px]" placeholder="Add a note about this customer..." defaultValue="Always requests extra sauce. Birthday: March 15" data-id="element-824"></textarea>
                  <Button className="self-end" icon={<Save size={16} data-id="element-826" />} data-id="element-825">
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        </div>}
    </div>;
}